import { Component } from '@angular/core';
import { ButtonModule } from "primeng/button";
import { RouterModule } from "@angular/router";
import { NgOptimizedImage } from "@angular/common";

@Component({
  selector: 'app-not-found',
  imports: [RouterModule, ButtonModule, NgOptimizedImage],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {

}
